export const getTokenFromUrl = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('token');
};

export const getProductIdFromUrl = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('product_id');
};

export const saveTokenToLocalStorage = (token: string): void => {
    localStorage.setItem('authToken', token);
};

export const saveProductIdToSessionStorage = (productId: string): void => {
    sessionStorage.setItem('redirectProductId', productId);
};

export const getTokenFromLocalStorage = (): string | null => {
    return localStorage.getItem('authToken');
};

export const getAdminTokenFromLocalStorage = (): string | null => {
    return localStorage.getItem('adminToken');
};

export const getProductIdFromSessionStorage = (): string | null => {
    return sessionStorage.getItem('redirectProductId');
};

export const clearUrlParams = (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
};

export const extractAndSaveAuthData = (): {
    token: string | null,
    productId: string | null
} => {
    const token = getTokenFromUrl();
    const productId = getProductIdFromUrl();

    if (token) {
        saveTokenToLocalStorage(token);
    }

    if (productId) {
        saveProductIdToSessionStorage(productId);
    }

    clearUrlParams();

    return { token, productId };
};